export enum GMBFStep {
  TariffSubStep1 = 'step1_tariffSubStep1',
  TariffSubStep2 = 'step1_tariffSubStep2',
  PersonalDataStep = 'step2_personalData',
  PaymentStep = 'step3_payment',
  SummaryStep = 'step4_summary',
  PaymentApprovementStep = 'step5_paymentApprovement',
}
